module.exports = __webpack_public_path__ + "static/media/057.4214cf72.jpg";